<script>
import DialogBaseColoredTitle from '@/components/common/Dialog/DialogBaseColoredTitle.vue'
import DialogBaseActions from '@/components/common/Dialog/DialogBaseActions.vue'
import DialogBaseText from '@/components/common/Dialog/DialogBaseText.vue'
import DialogBaseCloseIcon from '@/components/common/Dialog/DialogBaseCloseIcon.vue'
import { mapGetters } from 'vuex'

export default {
  components: {
    DialogBaseCloseIcon,
    DialogBaseText,
    DialogBaseActions,
    DialogBaseColoredTitle
  },
  data() {
    return {
      dialog: false,
      loading: false,
      notification: {
        state: false,
        timeout: 3000,
        type: 'component.inbox.create.success',
        content: ''
      },
      inboxName: '',
      deletionDeadlineModelValue: null
    }
  },
  computed: {
    ...mapGetters(['deletionDeadline']),
    deletionDeadlineErrors() {
      const errors = []
      if (this.deletionDeadlineModelValue !== null &&
        (this.deletionDeadlineModelValue < this.deletionDeadline.min ||
          this.deletionDeadlineModelValue > this.deletionDeadline.max)) {
        errors.push(this.$t('component.inbox.deletion.deadline.range'))
      }
      return errors
    }
  },
  methods: {
    addInbox() {
      this.loading = true
      this.$inboxService
        .createInbox({
          inboxName: this.inboxName,
          deletionDeadline: this.deletionDeadlineModelValue
        })
        .then(() => {
          this.$emit('created')
        })
        .catch((e) => {
          if (e.response.status === 409) {
            return this.showNotification('error',
              this.$t('component.inbox.already.exists'))
          }
          return this.showNotification('error',
            this.$t('component.inbox.create.error'))
        })
        .finally(() => {
          this.reset()
        })
    },
    /**
     * Reset all data
     */
    reset() {
      this.dialog = false
      this.loading = false
      this.inboxName = ''
      this.deletionDeadlineModelValue = null
    },
    showNotification(type, content) {
      this.notification.state = true
      this.notification.type = type
      this.notification.content = content
    }
  }
}
</script>
<template>
  <div>
    <!--    NOTIFICATION-->
    <v-snackbar
      v-model="notification.state"
      :color="notification.type"
      :timeout="notification.timeout"
      top>
      <span v-html="notification.content" />
      <v-btn color="white" text @click="notification.state = false">
        <v-icon size="20">mdi-close</v-icon>
      </v-btn>
    </v-snackbar>
    <!--    MODAL / DIALOG-->
    <v-dialog
      v-model="dialog"
      max-width="500"
      :fullscreen="$vuetify.breakpoint.xsOnly">
      <template #activator="{ on, attrs }">
        <v-btn-toggle class="me">
          <v-btn color="primary" style="opacity:1;color:white;" dark v-bind="attrs" v-on="on">
            <v-icon color="white">mdi-plus</v-icon>
            {{ $t('button.create.inbox') }}
          </v-btn>
        </v-btn-toggle>
      </template>
      <v-card>
        <DialogBaseColoredTitle color="primary">
          {{ $t('component.inbox.create') }}
        </DialogBaseColoredTitle>
        <DialogBaseCloseIcon color="white" @click="dialog = false" />
        <v-divider></v-divider>
        <v-expand-transition>
          <div>
            <DialogBaseText>
              <v-text-field
                id="inbox-name-text"
                v-model="inboxName"
                :label="$t('component.inbox.name')"
                outlined
                dense
                required />
              <v-text-field
                id="inbox-deletion-deadline-text"
                v-model.number="deletionDeadlineModelValue"
                :label="$t('component.inbox.deletion.deadline')"
                outlined
                dense
                required
                :error-messages="deletionDeadlineErrors"/>
            </DialogBaseText>
            <v-divider></v-divider>
            <DialogBaseActions>
              <v-btn
                id="saveOrganization"
                :loading="loading"
                class="text-center px-8"
                color="primary"
                :disabled="!inboxName
                || deletionDeadlineModelValue < deletionDeadline.min
                || deletionDeadlineModelValue > deletionDeadline.max"
                depressed
                @click.stop="addInbox">
                {{ $t('button.save') }}
              </v-btn>
            </DialogBaseActions>
          </div>
        </v-expand-transition>
      </v-card>
    </v-dialog>
  </div>
</template>
